import create from 'zustand';

import { IAppState } from './types';

const NUMBERS_RE = /-?\d+(\.\d+)?/;

const useAppState = create<IAppState>()((set) => ({
  file: null,
  blobUrl: '',
  uploadError: null,
  isProcessing: false,
  rotateDirection: null,
  canvasImageUrl: undefined,
  imageName: undefined,
  canvasImageFile: null,
  isOpen: false,
  isDownloaded: false,
  rotationAngles: [],
  currentIndex: 0,
  customAngle: 0,

  addImage: (file, blobUrl) =>
    set((state) => ({
      ...state,
      file,
      blobUrl,
      imageName: file.name,
      isProcessing: true,
      displayUploadSuccess: true,
      rotationAngles: [0],
      customAngle: 0,
    })),

  deleteImage: () =>
    set(() => ({
      file: null,
      blobUrl: '',
      uploadError: null,
      isProcessing: false,
      flipDirection: null,
      imageName: undefined,
      canvasImageFile: null,
      isOpen: false,
      angle: 0,
      rotationAngles: [],
      currentIndex: 0,
      customAngle: 0,
    })),

  setUploadError: (uploadError) =>
    set((state) => ({
      ...state,
      uploadError,
      isProcessing: false,
    })),

  setIsProcessing: (isProcessing) =>
    set((state) => ({
      ...state,
      isProcessing,
    })),

  setRotateDirection: (rotateDirection) =>
    set((state) => ({
      ...state,
      rotateDirection,
    })),

  setCanvasImageFile: (canvasImageFile) =>
    set((state) => ({
      ...state,
      canvasImageFile,
    })),

  setIsOpen: (isOpen) =>
    set((state) => ({
      ...state,
      isOpen,
    })),
  setIsDownloaded: (isDownloaded) =>
    set((state) => ({
      ...state,
      isDownloaded,
    })),
  setCurrentIndex: (currentIndex) =>
    set((state) => ({
      ...state,
      currentIndex,
    })),
  setAngle: (angle) => {
    const str = angle.toString();

    if (NUMBERS_RE.test(str)) {
      const num = parseInt(str);
      set((state) => ({
        ...state,
        rotationAngles: [...state.rotationAngles, num],
        currentIndex: state.currentIndex + 1,
      }));
    }
  },
  setRotationAngles: (rotationAngles) =>
    set((state) => ({
      ...state,
      rotationAngles,
    })),
  setCustomAngle: (customAngle) =>
    set((state) => ({
      ...state,
      customAngle,
    })),
}));

export default useAppState;
